"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyApiToken = exports.getApiToken = void 0;
const crypto_js_1 = __importDefault(require("crypto-js"));
let _apiToken = '';
let _apiTokenTime = -1;
let _apiAuthToken = '';
const _delimiter = '-*-';
function getNow() {
    return Math.floor(Date.now() / (1 * 3600 * 1000));
}
function getApiToken(authToken) {
    var _a;
    const now = getNow();
    if (now === _apiTokenTime && _apiAuthToken === authToken) {
        return _apiToken;
    }
    const dateStr = now.toString();
    const key = (_a = process.env.VUE_APP_99TALK_API_KEY) !== null && _a !== void 0 ? _a : '99talkApiDinosband';
    const mesg = `${dateStr}${_delimiter}${authToken}`;
    const token = crypto_js_1.default.AES.encrypt(mesg, key).toString();
    _apiToken = token;
    _apiTokenTime = now;
    _apiAuthToken = authToken;
    return token;
}
exports.getApiToken = getApiToken;
function verifyApiToken(apiToken, isSubscription) {
    var _a;
    const key = (_a = process.env.VUE_APP_99TALK_API_KEY) !== null && _a !== void 0 ? _a : '99talkApiDinosband';
    let decoded = '';
    try {
        // decoded = CryptoJS.AES.decrypt(apiToken, key).toString(CryptoJS.enc.Utf8)
        decoded = crypto_js_1.default.AES.decrypt(apiToken, key).toString(crypto_js_1.default.enc.Utf8);
    }
    catch (e) {
        // console.error('Failed to decode:', e)
        return undefined;
    }
    if (decoded) {
        if (decoded.includes(_delimiter)) {
            if (decoded.endsWith(_delimiter)) {
                // empty authToken
                return '';
            }
            else {
                const tokens = decoded.split(_delimiter);
                const date = parseInt(tokens[0]);
                const offsets = [0, -1, 1];
                let matched = false;
                if (isSubscription) {
                    // subscription인 경우에는 connection 시에 설정한 값이 사용되므로 시간에 따라 변경되지 않는다.
                    // 따라서 subscription인 경우에는 별도로 검사하지 않는다.
                    matched = !Number.isNaN(date) && date > 0;
                }
                else {
                    const now = getNow();
                    for (const offset of offsets) {
                        if (now + offset === date) {
                            matched = true;
                            break;
                        }
                    }
                }
                if (!matched) {
                    return undefined;
                }
                const authToken = tokens[1];
                return authToken;
            }
        }
    }
    return undefined;
}
exports.verifyApiToken = verifyApiToken;
